import SLATable from "./SLATable";
export default SLATable;
